import { normalize } from 'normalizr'
import { all } from 'redux-saga/effects'
import { postEntity } from 'redux/entities'
import pagaSaga from 'redux/pagination/sagas'
import actions from './actions'

const norm = data => normalize(data?.posts ?? [], [postEntity])

export default function* rootSaga() {
  yield all([...pagaSaga([actions.LIST_POSTS, actions.LIST_POSTS_NEXT], norm)])
}
